import { Link } from "react-router-dom";

export default function CtaBand() {
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=wide%20cinematic%20banner%20of%20burning%20embers%20and%20golden%20energy%20particles%20floating%20over%20dark%20background%2C%20dramatic%20fiery%20orange%20glow%2C%20abstract%20action%20manga%20energy%20aesthetic%2C%20moody%20atmosphere%2C%20high%20contrast%20warm%20lighting&width=1600&height=500&seq=cta-fire-2026&orientation=landscape"
          alt="火焰能量背景横幅"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-background-50/70 to-background-50/30"></div>
      </div>
      <div className="relative mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-xl">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 leading-tight">
            别再翻找了，<span className="fire-text">直接开刷</span>开挂剧情
          </h2>
          <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">
            热血战斗排行、无脑爽漫推荐、龙傲天与打脸爽文漫全部就绪，今天就从第一名开始看起。
          </p>
          <div className="mt-6 flex flex-col sm:flex-row items-center gap-3">
            <Link
              to="/ranking"
              className="inline-flex w-full sm:w-auto items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm md:text-base font-semibold text-background-50 hover:bg-primary-600 transition-colors"
            >
              <i className="ri-fire-fill"></i>开始今天的战斗
            </Link>
            <Link
              to="/about"
              className="inline-flex w-full sm:w-auto items-center justify-center gap-2 whitespace-nowrap rounded-full bg-background-50/70 backdrop-blur border border-foreground-300/40 px-7 py-3 text-sm md:text-base font-semibold text-foreground-950 hover:bg-background-50 transition-colors"
            >
              了解我们
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}